// extracted by mini-css-extract-plugin
module.exports = {"colorsList":"ProductCardColors_colorsList__vh_tl","colorsListItem":"ProductCardColors_colorsListItem__pSpuc"};